import { MediaEntityType } from '@ancon/wildcat-types'

import getMediaImageCdnUrl from '../../app/utils/getMediaImageCdnUrl'

export default function getProductImageUrl(
  tenantId: string,
  imageId: string,
  productId: string,
): string {
  return getMediaImageCdnUrl(
    tenantId,
    imageId,
    MediaEntityType.Product,
    productId,
  )
}
